$(document).ready(function () {
    $('.footer-mobile-button').on('click', function () {
        $(this).toggleClass('js_footer_menu');
        $(this).closest('div').children('ul').toggleClass('js_footer_menu');
    });
})